import { Assert } from '@/utils/assert'

export const appInfo = {
  // Reads and exposes variables from Webpack's define plugin
  //@ts-ignore
  appVersion: Assert.isDefined(__APP_VERSION__) as string,
  //@ts-ignore
  appBuildDateTime: Assert.isDefined(__APP_DATE_TIME_BUILD__) as string,
}
